class Subscribable {
    constructor() {
        this._subscriptions = [];
    }
    invoke(channel, data) {
        this._subscriptions.forEach((subscription) => {
            if (subscription.channel === channel) {
                subscription.listener(data);
            }
        });
    }
    subscribe(channel, listener) {
        this._subscriptions.push({
            channel,
            listener,
        });
        return () => this.unsubscribe(listener);
    }
    unsubscribe(listener) {
        const subscription = this._subscriptions.find((s) => s.listener === listener);
        if (subscription) {
            this._subscriptions.splice(this._subscriptions.indexOf(subscription), 1);
        }
    }
}
export default Subscribable;
//# sourceMappingURL=Subscribable.js.map